import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import courseService from 'ApiService/Admin/courseService';
import batchStructureService from 'ApiService/Admin/batchService';
import BatchStructureInfo from './Steps/BatchStructureInfo';
import { useContext } from 'react';
import { AuthContext } from 'contexts/AuthContext';

const Index = () => {
  const [departments, setDepartments] = useState([]);
  const [courses, setCourses] = useState([]);
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    department: '',
    courses: [],
  });

  const { state } = useContext(AuthContext);
  const role = state?.user?.role;

  const resolvedBranch =
    role === 'superadmin' ? state?.selectedBranch : state?.user?.branch?._id;

  const selectedBranch = resolvedBranch;

  /* ================= FETCH DEPARTMENTS ================= */
  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await courseService.getAllDepartments();
      if (res.data.success) {
        setDepartments(res.data.data || []);
      }
    } catch {
      toast.error('Failed to load departments');
    }
  };

  /* ================= FETCH COURSES BY DEPARTMENT ================= */
  const fetchCoursesByDepartment = async (departmentId) => {
    if (role === 'superadmin' && !selectedBranch) {
      setCourses([]);
      return;
    }

    try {
      const res = await courseService.getCoursesByDepartment(
        departmentId,
        selectedBranch
      );

      if (res.data.success) {
        setCourses(res.data.courses || []);
      } else {
        setCourses([]);
      }
    } catch {
      toast.error('Failed to load courses');
      setCourses([]);
    }
  };

  useEffect(() => {
    // superadmin ne branch change ki
    if (role === 'superadmin') {
      setCourses([]);
      setFormData((prev) => ({
        ...prev,
        courses: [],
      }));

      // agar department already selected hai → refetch
      if (formData.department && selectedBranch) {
        fetchCoursesByDepartment(formData.department);
      }
    }
  }, [selectedBranch]);

  /* ================= CREATE BATCH STRUCTURE ================= */
  const handleSubmit = async () => {
    if (disable || loading) return;

    try {
      setLoading(true);

      const payload = {
        name: formData.name,
        department: formData.department,
        courses: formData.courses,
      };

      console.log('CREATE BATCH STRUCTURE PAYLOAD:', payload);

      const res = await batchStructureService.createBatchStructure(payload);

      if (res.data.success) {
        toast.success(res.data.message);

        // reset form
        setFormData({
          name: '',
          department: '',
          courses: [],
        });

        setCourses([]);
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || 'Failed to create batch structure'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <BatchStructureInfo
        formData={formData}
        setFormData={setFormData}
        departments={departments}
        courses={courses}
        fetchCoursesByDepartment={fetchCoursesByDepartment}
        setDisable={setDisable}
      />

      <button
        disabled={disable || loading}
        onClick={handleSubmit}
        className="mt-6 rounded-xl bg-brand-900 px-6 py-2 text-white disabled:opacity-50"
      >
        Create Batch Structure
      </button>
    </div>
  );
};

export default Index;
